import {
  InquiryFetchArgs,
  InquiryStatusCount,
  getInquiryStatusCounts,
} from '../../assets/ts/data/inquiry/inquiry'
import useServerData from '../use-server-data'

function useInquiryStatusCounts(fetchArgs: InquiryFetchArgs) {
  const {
    data: inquiryStatusCounts,
    error: inquiryStatusCountsError,
    fetchData: fetchInquiryStatusCounts,
    isLoading: inquiryStatusCountsIsLoading,
  } = useServerData<InquiryStatusCount, InquiryFetchArgs>(
    getInquiryStatusCounts,
    fetchArgs
  )

  return {
    fetchInquiryStatusCounts,
    inquiryStatusCounts,
    inquiryStatusCountsError,
    inquiryStatusCountsIsLoading,
  }
}

export default useInquiryStatusCounts
